
<base-button
	*transloco="let t"
	class="btn-register"
	variant="success"
	[block]="block()"
	(click)="handleRegisterClick()">
	{{ t('actions.register') }}
</base-button>
